import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef, EventEmitter, Input, Output,
  ViewChild
} from '@angular/core';
import {DataService} from "../../services/data.service";
import {Overlayable} from "../../interfaces/overlayable";

@Component({
  selector: 'brt-teacher-timer-setup',
  templateUrl: './teacher-timer-setup.component.html',
  styleUrls: ['./teacher-timer-setup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TeacherTimerSetupComponent implements Overlayable, AfterViewInit {

  @Output('onClosed') onClosed = new EventEmitter();
  @ViewChild('mainEl') mainEl!: ElementRef;

  @Input('valueChangedCallback') valueChangedCallback!: (timeInSeconds: number) => void;
  @Input('maxTime') set setMaxTime(timeInSeconds: number) {
    console.log("timeInSeconds", timeInSeconds);
    this.maxSeconds = timeInSeconds % 60;
    this.maxMinutes = Math.floor(timeInSeconds / 60)

    this.pipeMinutes(this.currentMinutesString);
    this.pipeSeconds(this.currentSecondsString);
  }

  @Input("inputMode") inputMode: "all" | "button" = "all";

  mainElHtmlEl!: HTMLElement;

  outputValue = 0;

  maxSeconds = 0;
  maxMinutes = 0;
  public get maxTimeInSeconds() {
    return this.maxMinutes * 60 + this.maxSeconds;
  };

  currentMinutes = 30;
  currentSeconds = 0;

  currentMinutesString = this.currentMinutes.toString();
  currentSecondsString = this.currentSeconds.toString();

  currentFocus = -1;
  constructor(private data: DataService, private ref: ChangeDetectorRef) {
  }

  ngAfterViewInit() {
    this.mainElHtmlEl = this.mainEl.nativeElement as HTMLElement;
    this.updateOutputValue();
  }

  setFocus(number: number) {
    this.currentFocus = number;

    const targetInput = this.mainElHtmlEl.querySelector("#teacher-timer-setup-input-" + number);
    if(targetInput) {
      let input = targetInput as HTMLInputElement;
      input.focus({preventScroll: true});
    }
    // add click outside listener
    // add arrows listener
  }

  removeFocus(fromIdx: number) {
    if(this.currentFocus === fromIdx) {
      this.currentFocus = -1;
    }
  }


  onInputChange($event: string, number: number) {
    let newVal = $event.length === 0 ? 0 : parseInt($event);

    if(isNaN(newVal)) newVal = 0;
    if(newVal > 99) {
      const strVal = newVal.toFixed(0);
      newVal = parseInt(strVal.slice(0, 2));
    }

    // console.log(newVal);
    if(number === 0) {
      this.currentMinutes = newVal;
      this.currentMinutesString = "0";

      // console.log(this.currentMinutesString);
    } else if(number === 1) {
      this.currentSeconds = newVal;
      this.currentSecondsString = this.currentSeconds.toFixed(0);

    }
    this.ref.detectChanges();
  }

  onKeyUp($event: KeyboardEvent, number: number) {
    if(this.inputMode === "all") {
      const key = $event.key;
      let newValue = number === 0 ? this.currentMinutesString : this.currentSecondsString;
      if(newValue.startsWith("0")) newValue = newValue.substring(1);
      let newIntValue = parseInt(newValue);
      if(isNaN(newIntValue)) newIntValue = 0;

      if(key === "ArrowUp") {
        newIntValue++;
        newValue = newIntValue.toFixed(0);
      } else if(key === "ArrowDown") {
        newIntValue--;
        if(newIntValue < 0) newIntValue = 0;
        newValue = newIntValue.toFixed(0);
      } else if(key === "ArrowLeft") {
        this.setFocus(0);
      } else if(key === "ArrowRight") {
        this.setFocus(1);
      } else if(!isNaN(parseInt(key))) {
        if(newValue.length < 2) {
          newValue = `${newValue}${key}`;
        } else {
          newValue = key;
        }
      } else if(key === "Backspace") {
        if(newValue.length > 0) {
          newValue = newValue.substring(0, newValue.length - 1);
        }
      }

      if(number === 0) {
        this.pipeMinutes(newValue);
      } else if(number === 1) {
        this.pipeSeconds(newValue);
      }


      const input = $event.target as HTMLInputElement;
      input.value =  newValue;
    }
    // console.log($event.target);
    // console.log($event.key);


  }

  incrementMinutes(number: number) {
    let currentMinutes = parseInt(this.currentMinutesString);
    currentMinutes += number;

    this.pipeMinutes(currentMinutes.toString());
  }

  pipeMinutes(val: string) {
    let intValue = parseInt(val);
    if(isNaN(intValue)) intValue = 0;
    else if(intValue > 99) intValue = 99;
    else if(intValue < 0) intValue = 0;

    if(!this.validateNewTimeToMaxTime(intValue, this.currentSeconds, this.maxTimeInSeconds)) {
      intValue = this.maxMinutes;
      this.setSeconds(this.maxSeconds);
    }

    this.setMinutes(intValue);
  }

  pipeSeconds(val: string) {
    let intValue = parseInt(val);
    if(isNaN(intValue)) intValue = 0;
    else if(intValue > 59) intValue = 59;
    else if(intValue < 0) intValue = 0;

    if(!this.validateNewTimeToMaxTime(this.currentMinutes, intValue, this.maxTimeInSeconds)) {
      intValue = this.maxSeconds;
      this.setMinutes(this.maxMinutes);
    }
    this.setSeconds(intValue);
  }

  setMinutes(val: number) {
    this.currentMinutesString = val.toString();
    this.currentMinutes = val;
    this.updateOutputValue();
  }

  setSeconds(val: number) {
    this.currentSecondsString = val.toString();
    this.currentSeconds = val;
    this.updateOutputValue();
  }

  validateNewTimeToMaxTime(minutes: number, seconds: number, maxTimeInSeconds: number) {
    return minutes * 60 + seconds <= maxTimeInSeconds;
  }

  updateOutputValue() {
    this.outputValue = this.currentMinutes * 60 + this.currentSeconds;
    this.valueChangedCallback(this.outputValue);
  }
}
